__turbopack_context__.v({
  "content": "VzR6RG_content",
  "header": "VzR6RG_header",
  "summaryCard": "VzR6RG_summaryCard",
});
